import templateUrl from "emun.invoice/invoice-list-cards.htm";

export default () => ({ templateUrl });
